import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function ProductPresentation() {
  return <section className="py-24 px-4 bg-brand-dark text-brand-cream relative overflow-hidden" data-id="element-229">
      <div className="absolute inset-0 bg-leaf-pattern opacity-40 pointer-events-none" data-id="element-230" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-231">
        <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-232">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="flex-1 text-center md:text-left" data-id="element-233">
            <span className="text-brand-gold font-semibold tracking-widest uppercase text-sm mb-4 block" data-id="element-234">
              Presentando
            </span>
            <h2 className="text-5xl md:text-6xl font-bold font-heading mb-4 text-brand-cream" data-id="element-235">
              🌿 SNACK SIN ANTOJO 🌿
            </h2>
            <p className="text-2xl text-brand-lightGold font-heading italic mb-8" data-id="element-236">
              "Come rico. Come inteligente. Sin culpa."
            </p>

            <p className="text-lg text-brand-cream/80 mb-8 leading-relaxed" data-id="element-237">
              No es una dieta. No es un plan de restricción. No es otro libro de
              recetas "saludables" que se ven bien en Instagram pero saben a
              tristeza.
              <br data-id="element-238" />
              <br data-id="element-239" />
              <strong data-id="element-240">Es un sistema.</strong> Un sistema de respuesta al antojo
              — diseñado específicamente para el momento exacto en que tu cuerpo
              manda la señal de "necesito algo ya."
            </p>

            <div className="space-y-4 mb-8" data-id="element-241">
              {['Sacia físicamente', 'Satisface emocionalmente', 'Estabiliza biológicamente'].map((item, index) => <div key={index} className="flex items-center gap-3 justify-center md:justify-start" data-id="element-242">
                  <CheckCircle2 className="text-brand-gold w-6 h-6 flex-shrink-0" data-id="element-243" />
                  <span className="text-lg font-medium text-brand-cream" data-id="element-244">
                    {item}
                  </span>
                </div>)}
            </div>

            <p className="text-xl font-semibold text-brand-lightGold" data-id="element-245">
              Y cada una está lista en 10 minutos o menos.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9,
          rotate: 5
        }} whileInView={{
          opacity: 1,
          scale: 1,
          rotate: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="flex-1 relative" data-id="element-246">
            <div className="absolute -inset-10 bg-brand-gold/20 blur-3xl rounded-full" data-id="element-247" />
            <img src="https://cdn.magicpatterns.com/uploads/p3q6Hb6msyCehNqLg2mATK/snack_sin_antojo.png" alt="Snack Sin Antojo Book Cover" className="relative w-full max-w-md mx-auto rounded-2xl shadow-2xl border-4 border-brand-gold/30 rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-248" />
          </motion.div>
        </div>
      </div>
    </section>;
}